import React from 'react'
import { Modal, Container, Footer } from "./styles"

const ModalVideo = ({ onClose = () => { }, onConfirm = () => { }, handleModalStorage = () => { }, children, title, buttonText, MessageInline, exclusaoParam, width, height, footerRender = null }) => {
    return (
        <Modal>
            <Container>
                <button onClick={onClose}>X</button>
                <h1>{title}</h1>
                <br />
                {children}
                <Footer>
                    {footerRender ? footerRender : <div>
                        <button onClick={onConfirm}>{buttonText}</button>
                        <p onClick={handleModalStorage}>{MessageInline}</p>
                    </div>}
                </Footer>
            </Container>
        </Modal>
    );
}
export default ModalVideo;